import base, { APIDetail, APISearchParams, config } from "./base";

export interface APIFormulationApprover {
  id: identifier;
  name: string;
  email: string;
}

export interface APIFormulationApprovalCategory {
  code: string;
  name: string;
  isMandatory?: boolean;
  approvers: APIFormulationApprover[];
}

export interface APIFormulationApprovalComment {
  id: identifier;
  user: APIFormulationApprover;
  comment: string;
  postedAt: string;
}

export interface APIFormulationApproval {
  id: identifier;
  projectId: identifier;
  projectName: identifier;
  status: "pending" | "resubmit" | "completed";
  requestedBy: APIFormulationApprover;
  requestedAt: string;
  categories: APIFormulationApprovalCategory[];
  comments: APIFormulationApprovalComment[];
}

export interface APIFormulationApprovalList
  extends APIFormulationApproval {}
export interface APIFormulationApprovalSearchParams extends APISearchParams {
  project: identifier;
}

export const list = (
  page = 1,
  limit = config.defaultLimit,
  searchParams: APIFormulationApprovalSearchParams
) =>
  base.list<APIFormulationApprovalList, APIFormulationApprovalSearchParams>(
    `projects/${searchParams?.project}/formulation-approval/`,
    page,
    limit
  );

export interface APIFormulationApprovalDetail
  extends APIDetail<APIFormulationApproval> {}

export type APIFormulationApprovalInput = {
  categories: { code: string; approver_ids: identifier[] }[];
  comment?: string;
};

export const create = (
  projectId: identifier,
  data: APIFormulationApprovalInput
) =>
  base.post<APIFormulationApprovalDetail>(`projects/${projectId}/formulation-approval/`, {
    json: { ...data },
  });
